import React from 'react';
import ReactDOM from 'react-dom'

class Portal extends React.Component {

  constructor(props){
    super(props);

    // Create a New Portal Element
    this.el = document.createElement('div')
    this.el.setAttribute('data-portal','tcc-portal')

  }

  componentDidMount(){

    // Add element to the page & clear current html
    this.container = document.querySelector(this.props.selector);

    // Replace Content with a Portal
    if(this.props.insertBefore){
        this.container.insertBefore(this.el,this.container.childNodes[0]);
    } else {
        this.container.appendChild(this.el)
    }

    
    

  }

  componentWillUnmount(){

    // Remove Portal
    this.container.removeChild(this.el)

  }

  render(){
    return ReactDOM.createPortal(
      this.props.children,
      this.el,
    );
  }
}

export default Portal